import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { GeoLayer, AbstractLayer, AbstractLayerOptions } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'
import legendImage from '../../img/legend_borehole.png'
import { ContextTag } from '../wiki/Wiki'

/**
 * Map layer class for the main borehole WMS source from Geo.
 */
class BoreHoleLayer extends AbstractLayer implements GeoLayer {
  static readonly defaultParams: LayerParamsObject = {
    opacity: 1.0
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.BORE_HOLES,
      enabled: true,
      minZoom: 12,
      zIndex: 5
    }
    super({ ...defaultOptions, ...options })

    let { opacity } = options.params
    opacity = opacity === undefined ? BoreHoleLayer.defaultParams.opacity : opacity

    let layer = new ol.layer.Image({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.ImageWMS({
        url: 'https://data.geo.dk/mapv2/geo-services/ows',
        params: {
          layers: 'GEO-Services:borehole',
          token: options.token
        },
        projection: new ol.proj.Projection({
          code: 'EPSG:25832'
        })
      })
    })

    // Method copied from GAL codebase to speed up borehole WMS. TypeScript compiler might complain about setImageLoadFunction, but it does exist, ignore error.
    layer.getSource().setImageLoadFunction(function (image: any, src: any) {
      var bboxStr = getArgFromUrl(src, "BBOX", null);
      let srsStr = getArgFromUrl(src, "CRS", null);

      if (bboxStr && srsStr) {
          let bbox = parseBBOX(bboxStr, "%2C");

          let newExtentStr =
              bbox[0] + " " + bbox[1] + "," +
              bbox[0] + " " + bbox[3] + "," +
              bbox[2] + " " + bbox[3] + "," +
              bbox[2] + " " + bbox[1] + "," +
              bbox[0] + " " + bbox[1];

          src += "&cql_filter=WITHIN(geom,SRID=25832;POLYGON((" + newExtentStr + ")))";
      }

      (<HTMLImageElement>image.getImage()).src = src;
    
    });

    this.olLayer = layer
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.BORE_HOLES,
      name: 'map.layer.boreholes',
      group: LayerGroup.SUBSURFACE,
      ordering: 2,
      contextTags: [
        ContextTag.BOREHOLE
      ],
      themes: Object.values(DataTheme),
      capabilitiesUrl: '',
      legendEnabled: true,
      imageLegend: {
        legendImage: legendImage,
        imageWidth: 220
      },
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geo
    }
  }
}

function getArgFromUrl(url: string, argName: string, defaultValue: string | null = null) : string | null {
    let index = url.search(new RegExp(argName, "gi"));
    if (index > -1) {
        if (url.indexOf("&", index) > -1) {
            return url.substring(url.indexOf("=", index) + 1, url.indexOf("&", index));
        } else {
            return url.substring(url.indexOf("=", index) + 1);
        }
    }
    else {
        return defaultValue;
    }
}

function parseBBOX(bbox: string, seperator: string = ","): number[] {
    if (!bbox) return [];

    let parts = bbox.split(seperator);
    let res = [];
    for (let i = 0; i < parts.length; i++) {
        res.push(parseFloat(parts[i]));
    }

    return res;
}

export default BoreHoleLayer
